import React, { useState, Fragment } from 'react'
import { Link } from 'react-router-dom'

import PropTypes from 'prop-types'

import './pricing14.css'

const Pricing14 = (props) => {
  const [isMonthly, setIsMonthly] = useState(true)
  return (
    <div className="pricing14-pricing23 thq-section-padding">
      <div className="pricing14-max-width thq-section-max-width">
        <div className="pricing14-section-title">
          <div className="pricing14-content">
            <h1 className="pricing14-text10 HeadingOne">
              {props.heading ?? (
                <Fragment>
                  <span className="pricing14-text51">
                    <span>Passez dans le futur,</span>
                    <br></br>
                    <span>Sans exploser votre budget</span>
                  </span>
                </Fragment>
              )}
            </h1>
            <p className="pricing14-text11 HeadingThree">
              {props.content2 ?? (
                <Fragment>
                  <span className="pricing14-text37">
                    <span>
                      Si votre business n&apos;entre pas dans les cases,
                      contactez notre équipe commerciale, nous serions ravis
                      d&apos;entendre parler de votre situation
                    </span>
                    <span> </span>
                  </span>
                </Fragment>
              )}
            </p>
          </div>
        </div>
        {isMonthly && (
          <div className="pricing14-container">
            <div className="pricing14-column1 thq-card">
              <div className="pricing14-price1">
                <div className="pricing14-price2">
                  <p className="pricing14-text12 thq-body-large">
                    {props.plan1 ?? (
                      <Fragment>
                        <span className="pricing14-text57">Plan Startup</span>
                      </Fragment>
                    )}
                  </p>
                  <h3 className="pricing14-text13 thq-heading-3">
                    {props.plan1Price ?? (
                      <Fragment>
                        <span className="pricing14-text40">$20/mo</span>
                      </Fragment>
                    )}
                  </h3>
                  <p className="thq-body-large">
                    {props.plan1Yearly ?? (
                      <Fragment>
                        <span className="pricing14-text45">or $200 yearly</span>
                      </Fragment>
                    )}
                  </p>
                </div>
                <div className="pricing14-list1">
                  <div className="pricing14-list-item10">
                    <svg viewBox="0 0 1024 1024" className="thq-icon-small">
                      <path d="M384 690l452-452 60 60-512 512-238-238 60-60z"></path>
                    </svg>
                    <span className="thq-body-small">
                      {props.plan1Feature1 ?? (
                        <Fragment>
                          <span className="pricing14-text48">
                            Feature text goes here
                          </span>
                        </Fragment>
                      )}
                    </span>
                  </div>
                  <div className="pricing14-list-item11">
                    <svg viewBox="0 0 1024 1024" className="thq-icon-small">
                      <path d="M384 690l452-452 60 60-512 512-238-238 60-60z"></path>
                    </svg>
                    <span className="thq-body-small">
                      {props.plan1Feature2 ?? (
                        <Fragment>
                          <span className="pricing14-text61">
                            Feature text goes here
                          </span>
                        </Fragment>
                      )}
                    </span>
                  </div>
                  <div className="pricing14-list-item12">
                    <svg viewBox="0 0 1024 1024" className="thq-icon-small">
                      <path d="M384 690l452-452 60 60-512 512-238-238 60-60z"></path>
                    </svg>
                    <span className="thq-body-small">
                      {props.plan1Feature3 ?? (
                        <Fragment>
                          <span className="pricing14-text43">
                            Feature text goes here
                          </span>
                        </Fragment>
                      )}
                    </span>
                  </div>
                  <div className="pricing14-list-item13">
                    <svg viewBox="0 0 1024 1024" className="thq-icon-small">
                      <path d="M384 690l452-452 60 60-512 512-238-238 60-60z"></path>
                    </svg>
                    <span className="thq-body-small">
                      {props.plan1Feature33 ?? (
                        <Fragment>
                          <span className="pricing14-text36">
                            Feature text goes here
                          </span>
                        </Fragment>
                      )}
                    </span>
                  </div>
                  <div className="pricing14-list-item14">
                    <svg viewBox="0 0 1024 1024" className="thq-icon-small">
                      <path d="M384 690l452-452 60 60-512 512-238-238 60-60z"></path>
                    </svg>
                    <span className="thq-body-small">
                      {props.plan1Feature332 ?? (
                        <Fragment>
                          <span className="pricing14-text44">
                            Feature text goes here
                          </span>
                        </Fragment>
                      )}
                    </span>
                  </div>
                  <div className="pricing14-list-item15">
                    <svg viewBox="0 0 1024 1024" className="thq-icon-small">
                      <path d="M384 690l452-452 60 60-512 512-238-238 60-60z"></path>
                    </svg>
                    <span className="thq-body-small">
                      {props.plan1Feature331 ?? (
                        <Fragment>
                          <span className="pricing14-text55">
                            Feature text goes here
                          </span>
                        </Fragment>
                      )}
                    </span>
                  </div>
                </div>
              </div>
              <Link
                to="/contact"
                className="pricing14-button1 thq-button-outline thq-button-animated"
              >
                <span className="thq-body-small">
                  {props.plan1Action ?? (
                    <Fragment>
                      <span className="pricing14-text47">Get started</span>
                    </Fragment>
                  )}
                </span>
              </Link>
            </div>
            <div className="pricing14-column2 thq-card">
              <div className="pricing14-price3">
                <div className="pricing14-price4">
                  <p className="pricing14-text22 thq-body-large">
                    {props.plan2 ?? (
                      <Fragment>
                        <span className="pricing14-text60">
                          Plan Entreprise
                        </span>
                      </Fragment>
                    )}
                  </p>
                  <h3 className="pricing14-text23 thq-heading-3">
                    {props.plan2Price ?? (
                      <Fragment>
                        <span className="pricing14-text35">$29/mo</span>
                      </Fragment>
                    )}
                  </h3>
                  <p className="thq-body-large">
                    {props.plan2Yearly ?? (
                      <Fragment>
                        <span className="pricing14-text49">or $299 yearly</span>
                      </Fragment>
                    )}
                  </p>
                </div>
                <div className="pricing14-list2">
                  <div className="pricing14-list-item16">
                    <svg viewBox="0 0 1024 1024" className="thq-icon-small">
                      <path d="M384 690l452-452 60 60-512 512-238-238 60-60z"></path>
                    </svg>
                    <span className="thq-body-small">
                      {props.plan2Feature1 ?? (
                        <Fragment>
                          <span className="pricing14-text42">
                            Feature text goes here
                          </span>
                        </Fragment>
                      )}
                    </span>
                  </div>
                  <div className="pricing14-list-item17">
                    <svg viewBox="0 0 1024 1024" className="thq-icon-small">
                      <path d="M384 690l452-452 60 60-512 512-238-238 60-60z"></path>
                    </svg>
                    <span className="thq-body-small">
                      {props.plan2Feature2 ?? (
                        <Fragment>
                          <span className="pricing14-text41">
                            Feature text goes here
                          </span>
                        </Fragment>
                      )}
                    </span>
                  </div>
                  <div className="pricing14-list-item18">
                    <svg viewBox="0 0 1024 1024" className="thq-icon-small">
                      <path d="M384 690l452-452 60 60-512 512-238-238 60-60z"></path>
                    </svg>
                    <span className="thq-body-small">
                      {props.plan2Feature3 ?? (
                        <Fragment>
                          <span className="pricing14-text58">
                            Feature text goes here
                          </span>
                        </Fragment>
                      )}
                    </span>
                  </div>
                  <div className="pricing14-list-item19">
                    <svg viewBox="0 0 1024 1024" className="thq-icon-small">
                      <path d="M384 690l452-452 60 60-512 512-238-238 60-60z"></path>
                    </svg>
                    <span className="thq-body-small">
                      {props.plan2Feature4 ?? (
                        <Fragment>
                          <span className="pricing14-text62">
                            Feature text goes here
                          </span>
                        </Fragment>
                      )}
                    </span>
                  </div>
                  <div className="pricing14-list-item20">
                    <svg viewBox="0 0 1024 1024" className="thq-icon-small">
                      <path d="M384 690l452-452 60 60-512 512-238-238 60-60z"></path>
                    </svg>
                    <span className="thq-body-small">
                      {props.plan2Feature43 ?? (
                        <Fragment>
                          <span className="pricing14-text34">
                            Feature text goes here
                          </span>
                        </Fragment>
                      )}
                    </span>
                  </div>
                  <div className="pricing14-list-item21">
                    <svg viewBox="0 0 1024 1024" className="thq-icon-small">
                      <path d="M384 690l452-452 60 60-512 512-238-238 60-60z"></path>
                    </svg>
                    <span className="thq-body-small">
                      {props.plan2Feature42 ?? (
                        <Fragment>
                          <span className="pricing14-text46">
                            Feature text goes here
                          </span>
                        </Fragment>
                      )}
                    </span>
                  </div>
                  <div className="pricing14-list-item22">
                    <svg viewBox="0 0 1024 1024" className="thq-icon-small">
                      <path d="M384 690l452-452 60 60-512 512-238-238 60-60z"></path>
                    </svg>
                    <span className="thq-body-small">
                      {props.plan2Feature422 ?? (
                        <Fragment>
                          <span className="pricing14-text50">
                            Feature text goes here
                          </span>
                        </Fragment>
                      )}
                    </span>
                  </div>
                  <div className="pricing14-list-item23">
                    <svg viewBox="0 0 1024 1024" className="thq-icon-small">
                      <path d="M384 690l452-452 60 60-512 512-238-238 60-60z"></path>
                    </svg>
                    <span className="thq-body-small">
                      {props.plan2Feature421 ?? (
                        <Fragment>
                          <span className="pricing14-text56">
                            Feature text goes here
                          </span>
                        </Fragment>
                      )}
                    </span>
                  </div>
                </div>
              </div>
              <Link
                to="/contact"
                className="pricing14-button2 thq-button-filled thq-button-animated"
              >
                <span className="pricing14-text33 thq-body-small">
                  {props.plan2Action ?? (
                    <Fragment>
                      <span className="pricing14-text59">Get started</span>
                    </Fragment>
                  )}
                </span>
              </Link>
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

Pricing14.defaultProps = {
  plan2Feature43: undefined,
  plan2Price: undefined,
  plan1Feature33: undefined,
  content2: undefined,
  plan1Price: undefined,
  plan2Feature2: undefined,
  plan2Feature1: undefined,
  plan1Feature3: undefined,
  plan1Feature332: undefined,
  plan1Yearly: undefined,
  plan2Feature42: undefined,
  plan1Action: undefined,
  plan1Feature1: undefined,
  plan2Yearly: undefined,
  plan2Feature422: undefined,
  heading: undefined,
  plan1Feature331: undefined,
  plan2Feature421: undefined,
  plan1: undefined,
  plan2Feature3: undefined,
  plan2Action: undefined,
  plan2: undefined,
  plan1Feature2: undefined,
  plan2Feature4: undefined,
}

Pricing14.propTypes = {
  plan2Feature43: PropTypes.element,
  plan2Price: PropTypes.element,
  plan1Feature33: PropTypes.element,
  content2: PropTypes.element,
  plan1Price: PropTypes.element,
  plan2Feature2: PropTypes.element,
  plan2Feature1: PropTypes.element,
  plan1Feature3: PropTypes.element,
  plan1Feature332: PropTypes.element,
  plan1Yearly: PropTypes.element,
  plan2Feature42: PropTypes.element,
  plan1Action: PropTypes.element,
  plan1Feature1: PropTypes.element,
  plan2Yearly: PropTypes.element,
  plan2Feature422: PropTypes.element,
  heading: PropTypes.element,
  plan1Feature331: PropTypes.element,
  plan2Feature421: PropTypes.element,
  plan1: PropTypes.element,
  plan2Feature3: PropTypes.element,
  plan2Action: PropTypes.element,
  plan2: PropTypes.element,
  plan1Feature2: PropTypes.element,
  plan2Feature4: PropTypes.element,
}

export default Pricing14
